<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索供应商..."
          @on-change="searchSupplier"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        >
        </Input>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadSupplier"
          show-total
          simple
          style="margin-right: 24px"
        />
        <Button
          v-if="
            currentUser.superAdmin
          "
          @click="$refs.ImportSupplierModal.openModal()"
          style="margin-right: 12px"
        >Excel导入供应商</Button>
        <Button
          type="primary"
          @click="openCreateSupplierDrawer()"
        >新增供应商</Button>
      </div>
    </div>
    <div
      class="table-wrapper"
      ref="tableWrapper"
    >
      <Table
        :columns="columns"
        :data="supplierList"
        :height="tableHeight"
      >
      </Table>
    </div>
    <EditSupplierDrawer ref="EditSupplierDrawer" />
    <ImportSupplierModal ref="ImportSupplierModal" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import EditSupplierDrawer from "./EditSupplierDrawer";
import ImportSupplierModal from "./ImportSupplierModal";
import _ from "lodash";
import dayjs from "dayjs";

export default {
  name: "SupplierPage",
  components: { EditSupplierDrawer, ImportSupplierModal },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 80,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "供应商名",
          key: "code",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    cursor: "pointer",
                    color: "#42b983",
                  },
                  on: {
                    click: () => {
                      this.$refs.EditSupplierDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.name ? params.row.name : ""
              ),
            ]);
          },
        },
        {
          title: "简称",
          key: "abbr",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",

                params.row.abbr
              ),
            ]);
          },
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "left",
          render: (h, params) =>
            h("span", params.row.createdBy ? params.row.createdBy.name : ""),
        },
      ],
      filterQuery: {},
      limit: 20,
      tableHeight: 300,
    };
  },
  computed: mapState({
    supplierList: (state) => state.supplier.supplierList,
    totalRows: (state) => state.supplier.totalCounts,
    currentUser: (state) => state.auth.currentUser,
  }),
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getSupplier: "supplier/getSupplierAction",
    }),
    async loadSupplier(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText && this.searchText.trim() !== "") {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        await this.getSupplier(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSupplier: _.debounce(function () {
      this.page = 0;
      this.loadSupplier();
    }, 1000),
    openCreateSupplierDrawer() {
      this.$refs.EditSupplierDrawer.openDrawer();
    },
  },
  async created() {
    this.loadSupplier();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

.handle-right
  display flex
  align-items center
  justify-content space-between

.table-wrapper
  width 100%
  height calc(100% - 48px)

.container
  overflow-y auto

.inputfile
  // display: none;
  width 0.1px
  height 0.1px
  opacity 0
  overflow hidden
  position absolute
  z-index -1

.custom-file-upload
  border 1px solid rgb(220, 222, 226)
  display inline-block
  padding 6px 12px
  margin-right 12px
  cursor pointer
  font-size 12px
  border-radius 4px
  user-select none
  touch-action manipulation
  color #515a6e
  transition color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear

.inputfile + label:hover
  color #0c89f0
  border-color #0c89f0
</style>
